import { WEBSITE_HERO_SOURCE_ENABLED } from '../config/websiteHero';
import { useHeroMediaExamples } from './useAdmin';
import { useWebsiteHeroMedia } from './useWebsiteHeroMedia';

// One source per build. Keep the existing feed until permissions and the new
// catalogue are ready; after cutover, never fall back to the app's media.
export const useHeroArtwork = WEBSITE_HERO_SOURCE_ENABLED
  ? useWebsiteHeroMedia
  : useHeroMediaExamples;
